export const formWrapper = () => ({
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '3rem',
        padding: '2rem',
        borderRadius: '5px',
        boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
        backgroundColor: "#eee"
    },
    print: {
        backgroundColor: '#009900',
        color: 'white',
        margin: '0px',
    },
    reset: {
        backgroundColor: '#880000',
        color: 'white',
        margin: '-35px 0px 0px',
    },
    load: {
        backgroundColor: '#FF6600',
        color: 'white',
        margin: '-35px 0px 0px',
    }
});

export const personal = () => ({
    title: {
        fontWeight: 'bolder',
        fontSize: '24px',
        textAlign: 'left',
        paddingLeft: '5px',
    },
    input: {
        backgroundColor: 'white',
        margin: '5px 0px',
        borderRadius: '5px',
        paddingLeft: '10px',
    },
});

export const education = () => ({
    root: {
        direction: 'column',
    },
    title: {
        fontWeight: 'bolder',
        fontSize: '24px',
        textAlign: 'left',
        paddingLeft: '5px',
    },
    input: {
        backgroundColor: 'white',
        margin: '5px 0px',
        borderRadius: '5px',
        paddingLeft: '10px',
    },
    add: {
        backgroundColor: '#181818',
        color: 'white',
        margin: '10px 0px',
    },
    delete: {
        backgroundColor: '#181818',
        color: 'white',
        margin: '10px 0px 5px',
    }
});

export const experience = () => ({
    root: {
        direction: 'column',
    },
    title: {
        fontWeight: 'bolder',
        fontSize: '24px',
        textAlign: 'left',
        paddingLeft: '5px',
    },
    input: {
        backgroundColor: 'white',
        margin: '5px 0px',
        borderRadius: '5px',
        paddingLeft: '10px',
    },
    inputDescription: {
        backgroundColor: 'white',
        margin: '5px 0px',
        borderRadius: '5px',
        paddingLeft: '10px',
    },
    add: {
        backgroundColor: '#181818',
        color: 'white',
        margin: '10px 0px',
    },
    delete: {
        backgroundColor: '#181818',
        color: 'white',
        margin: '10px 0px 5px',
    }
});

export const project = () => ({
    root: {
        direction: 'column',
    },
    title: {
        fontWeight: 'bolder',
        fontSize: '24px',
        textAlign: 'left',
        paddingLeft: '5px',
    },
    input: {
        backgroundColor: 'white',
        margin: '5px 0px',
        borderRadius: '5px',
        paddingLeft: '10px',
    },
    inputDescription: {
        backgroundColor: 'white',
        margin: '5px 0px',
        borderRadius: '5px',
        paddingLeft: '10px',
    },
    add: {
        backgroundColor: '#181818',
        color: 'white',
        margin: '10px 0px',
    },
    delete: {
        backgroundColor: '#181818',
        color: 'white',
        margin: '10px 0px 5px',
    }
});
